import moment from 'moment';

const monthFormat = 'MM.YYYY';
const legacyDateFormat = 'DD.MM.YYYY';

export const getScheduleMonth = (schedule, monthKey, dateKey) => {
  const month = moment(
    schedule?.period?.[monthKey] || schedule?.[monthKey],
    monthFormat,
    true
  );

  if (month.isValid()) {
    return month;
  }

  const date = moment(schedule?.[dateKey], legacyDateFormat, true);

  return date.isValid() ? date.startOf('month') : null;
};

export const getSchedulePeriod = (schedule) => {
  const startMonth = getScheduleMonth(schedule, 'startMonth', 'startDate');
  const endMonth = getScheduleMonth(schedule, 'endMonth', 'endDate');

  if (!startMonth || !endMonth || startMonth.isAfter(endMonth, 'month')) {
    return null;
  }

  return { startMonth, endMonth };
};
